import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  useAnalyzeCompanyMutation,
  useCompanyVariableMutation,
  useCreateCompanyMutation,
  useDeleteCompanyVariableMutation,
  useDeleteSelectedCompanyVariableMutation,
  useGetAllCompanyVariablesQuery,
  useGetSingleCompanyMutation,
  useLinkSingleCompanyToWebsiteMutation,
  useUpdateSingleCompanyMutation,
} from "../../../redux/slices/profileApiSlice";
import { CompanyInitialValues, CompanySchema } from "../helper";
import DefaultGV from "./DefaultGV";

const Company = () => {
  const { t } = useTranslation();
  const [counter, setCounter] = useState(0);

  const currentProject = useSelector((state) => state?.project);
  const isInitialized = currentProject?.isInitialized;
  const website_url = currentProject?.project?.id
    ? currentProject?.project?.id
    : null;

  const [company, { isLoading }] = useCompanyVariableMutation();
  const [singleCompany, { isLoading: loadingSingle }] =
    useGetSingleCompanyMutation();
  const [updateCompany, { isLoading: loadingUpdate }] =
    useUpdateSingleCompanyMutation();
  const [linkCompanyToWebsite, { isLoading: linkUpdate }] =
    useLinkSingleCompanyToWebsiteMutation();
  const {
    data: companies,
    isLoading: loadingCompanies,
    refetch,
  } = useGetAllCompanyVariablesQuery(
    { website_url },
    {
      skip: isInitialized === false && currentProject?.project != null,
    }
  );
  const [deleteCompany, { isLoading: loadingDelete }] =
    useDeleteCompanyVariableMutation();
  const [
    deleteSelectedCompanyVariable,
    { isLoading: loadingDeleteSelectedCompanyVariable },
  ] = useDeleteSelectedCompanyVariableMutation();

  const [analyzeCompany, { isLoading: loadingAnalyze }] =
    useAnalyzeCompanyMutation();
  const [createCompany, { isLoading: loadingCreate }] =
    useCreateCompanyMutation();

  const variables = companies?.data ? companies?.data : [];

  useEffect(() => {
    if (isInitialized) {
      refetch();
    }
  }, [counter]);

  return (
    <DefaultGV
      counter={counter}
      setCounter={setCounter}
      variable={company}
      loadingVariable={isLoading}
      singleVariable={singleCompany}
      updateVariable={updateCompany}
      loadingUpdate={loadingUpdate}
      linkVariableToWebsite={linkCompanyToWebsite}
      variables={variables}
      refetch={refetch}
      deleteVariable={deleteCompany}
      loadingDelete={loadingDelete}
      analyzeVariable={analyzeCompany}
      loadingAnalyze={loadingAnalyze}
      createVariable={createCompany}
      loadingCreate={loadingCreate}
      variableId={"company"}
      variableTitle={t("Brand-identity", "Identité de marque")}
      variableNameAndPronoun={t("The-brand-identity", "L'identité de marque")}
      variableImage={null}
      variableFull={"company_full"}
      initialValues={CompanyInitialValues}
      validationSchema={CompanySchema}
      manualText={
        "Créez manuellement votre identité. Vous pouvez suivre les différents points pour vous aiguiller puis repasser sur le contenu, ou tout simplement rédiger votre identité de 0."
      }
      manualBtnText={t("Create-identity", "Créer l'identité")}
      autoText={
        "Entrez simplement l'URL de votre site web pour lequel vous souhaitez que l'IA rédige du contenu. Cliquez sur le bouton \"Analyser l'identité\" et l'IA se charge du reste !"
      }
      autoBtnText={t("Analyse-company", "Analyser l'identité")}
      bulkDeleteVariables={deleteSelectedCompanyVariable}
    />
  );
};

export default Company;
